'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useRef, useState, } from 'react';
import { Experiment } from '@amplitude/experiment-js-client';
import { getAndSetDeviceId } from './getDeviceId';
import useStoredAmplitudeVariants from '../hooks/useStoredAmplitudeVariants';
export const ExperimentContext = createContext({});
export const ExperimentProvider = ({ apiKey = 'NO_KEY', children, }) => {
    const storedVariants = useStoredAmplitudeVariants(apiKey);
    const [variants, setVariants] = useState(storedVariants || {});
    const [isLoading, setIsLoading] = useState(true);
    const clientRef = useRef(undefined);
    useEffect(() => {
        const client = Experiment.initializeWithAmplitudeAnalytics(apiKey, {
            serverZone: 'eu',
            fetchTimeoutMillis: 3000,
            retryFetchOnFailure: false,
        });
        clientRef.current = client;
        void (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const device_id = getAndSetDeviceId();
                const user = device_id ? { device_id } : {};
                yield client.fetch(user);
                setVariants(client.all());
            }
            catch (error) {
                //
            }
            finally {
                setIsLoading(false);
            }
        }))();
    }, [apiKey]);
    return (<ExperimentContext.Provider value={{
            variants,
            isLoading,
            client: clientRef.current,
            overrideVariants: setVariants,
        }}>
      {children}
    </ExperimentContext.Provider>);
};
export const useExperiments = () => useContext(ExperimentContext);
